import { useState } from "react";
import { DashboardHolding } from "./components/DashboardHolding/DashboardHolding";
import { CashFlowHolding } from "./components/FlowHolding/CashFlowHolding";
import './styles.scss'
import FeatherIcon from "feather-icons-react";
import Dashboard from "../../../assets/svg/svg_icons/dashboardHolding.svg";
import FlujoCaja from "../../../assets/svg/svg_icons/flujoCajaHolding.svg";

export const HoldingApp = ({ selectedCompanies }) => {
  const tabs = [
    { id: "dashboard", label: "Dashboard", icon: Dashboard },
    { id: "cashFlow", label: "Flujo de Caja", icon: FlujoCaja },
    // Puedes añadir más tabs aquí
  ];

  const [selectedTab, setSelectedTab] = useState(tabs[0].id);

  return (
    <div className="tw-flex tw-flex-col tw-mt-10">
      {/* Contenedor de las pestañas */}
      <div className="tw-flex tw-flex-col tw-border-b tw-border-gray-200">
        <div className="tw-flex tw-justify-between">
          <div className="tw-flex">
            {tabs.map((tab) => (
              <div
                key={tab.id}
                className={`tw-py-3 tw-px-5 tw-cursor-pointer tw-text-sm tw-font-semibold tw-flex tw-gap-1 ${selectedTab === tab.id
                  ? "tw-text-[#0099FF] tw-bg-white tw-rounded-t borderBlue"
                  : "tw-text-gray-400 borderGray"
                  }`}
                onClick={() => setSelectedTab(tab.id)}
              >
                {/* <FeatherIcon icon={tab.icon} size={13} /> */}
                <img
                  style={{
                    height: "13px",
                    width: "13px",
                    filter: selectedTab === tab.id
                      ? "invert(41%) sepia(40%) saturate(2717%) hue-rotate(182deg) brightness(101%) contrast(107%)" // Color cuando está seleccionado (#0099FF)
                      : "invert(100%) sepia(3%) saturate(298%) hue-rotate(251deg) brightness(112%) contrast(87%)"
                  }}
                  src={tab.icon}
                  alt="logo"
                />
                {tab.label}
              </div>
            ))}
          </div>
          <div>
            <a href="https://app.pepper.cl" target="_blank" rel="noopener noreferrer">
              <button className="tw-py-2 tw-px-6 tw-bg-[#0099FF] tw-border tw-border-solid tw-border-[#0099FF] tw-rounded tw-text-white">
                Regresar
              </button>
            </a>
          </div>
        </div>
      </div>

      {/* Contenido de las pestañas */}
      <div className="tw-py-4">
        {selectedTab === "dashboard" && <DashboardHolding selectedCompanies={selectedCompanies} />}
        {selectedTab === "cashFlow" && <CashFlowHolding selectedCompanies={selectedCompanies} />}
      </div>
    </div>
  );
};
